const styles = {
  tableWrapper: {
    marginBottom: 16,
  },
  table: {
    minWidth: 650,
  },
  borderBottom: {
    borderBottom: '1px solid #333333',
    width: 'fit-content',
  },
  dashboardsWrapper: {
    padding: '20px 35px 20px 40px',
  },
  loadingWrapper: {
    height: '60vh',
  },
}

export default styles
